module.exports = __webpack_public_path__ + "assets/img/collection2.026ef86c.svg";